import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import AttachmentsLoader from './AttachmentsLoader';
import AttachmentRenderer from '../../lazy/AttachmentRenderer';
import { AUTH_LEVELS } from '../../auth/Authorized';

const Attachments = ({ attachments, buildingId, userAuthLevel }) => (
  <div className="attachments-sidebar">
    {(attachments?.length > 0 || userAuthLevel <= AUTH_LEVELS.ORG_ADMIN) && (
      <Typography variant="subtitle1">Building Attachments</Typography>
    )}
    <AttachmentsLoader buildingId={buildingId} key={`a-loader-${buildingId}`} />
    {attachments.map((a) => (
      <AttachmentRenderer attachment={a} key={`a-${a.id}`} />
    ))}
  </div>
);

Attachments.propTypes = {
  buildingId: PropTypes.number.isRequired,
  attachments: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      url: PropTypes.string.isRequired,
      filename: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default connect(
  ({ entities: { attachments }, user: { userAuthLevel } }, { buildingId }) => ({
    attachments: attachments[buildingId] || [],
    userAuthLevel,
  })
)(Attachments);
